import React from 'react';
import { useHistory } from "react-router";
import { getCashFlow } from "api/urls";
import TableContainer from 'components/wrapper/TableContainer';

const CashFlow = (props) => {

    const history = useHistory()
    const unWantedKeys = ['as_on_date', 'created_at', 'updated_at', 'company_id', 'period', 'data_type', 'id', 'company']

    return (
        <div  {...props}>
            <TableContainer
                url={getCashFlow(history.location.search)}
                title={"Cash Flows"}
                unWantedKeys={unWantedKeys}
            />
        </div>

    )
};

export default (CashFlow);
